export const OtherSuperType = 'Other';
export var OtherTypes;
(function (OtherTypes) {
    OtherTypes[OtherTypes["RegimentOfRenown"] = 0] = "RegimentOfRenown";
    OtherTypes[OtherTypes["BattleTacticCard"] = 1] = "BattleTacticCard";
    OtherTypes[OtherTypes["Army"] = 2] = "Army";
    OtherTypes[OtherTypes["Unknown"] = 1000] = "Unknown";
})(OtherTypes || (OtherTypes = {}));
export const otherTypesToString = (type) => {
    switch (type) {
        case OtherTypes.RegimentOfRenown:
            return 'Regiment of Renown';
        case OtherTypes.BattleTacticCard:
            return 'Battle Tactic Card';
        case OtherTypes.Army:
            return 'Army';
        default:
            return 'Unknown';
    }
};
